const menu = {
    label: 'Relatório',
    icon: 'pi pi-file-excel',
    to: '/sol/relatorio',
    rules: ['SOL-001'],
};

export default menu;
